import { APP_CONFIG } from '../config/generated';
import { logger } from '../utils/logger';

/**
 * Create a Stripe Billing Portal session for the current user.
 * Returns the portal URL on success, or null on failure.
 */
export const createBillingPortalSession = async (user: any): Promise<string | null> => {
  try {
    const idToken = localStorage.getItem('cognito_id_token');
    if (!idToken) {
      logger.error('[Billing] No ID token when creating billing portal session');
      return null;
    }

    const mode = (APP_CONFIG as any).mode || 'dev';
    const envConfig = (APP_CONFIG as any).ENV_CONFIGS?.[mode] || APP_CONFIG.ENV_CONFIGS.dev;
    const backendUrl = (envConfig?.API || 'http://localhost:5050').replace(/\/$/, '');
    const { getApiHeaders } = await import('../utils/apiHeaders');

    const resp = await fetch(`${backendUrl}/api/billing/portal/session`, {
      method: 'POST',
      headers: getApiHeaders(),
    });

    const data = await resp.json().catch(() => ({}));
    if (!resp.ok || !data.portal_url) {
      logger.error('[Billing] Failed to create billing portal session', data);
      return null;
    }

    logger.log('[Billing] Billing portal session created');
    return data.portal_url as string;
  } catch (error) {
    logger.error('[Billing] Error creating billing portal session', error);
    return null;
  }
};


